<template>
  <v-dialog v-model="dialog" max-width="900" scrollable @click:outside="$emit('update:activated', false)">
    <v-card>
      <v-card-title class="font-weight-bold headline">Selecionar Relatório:</v-card-title>
      <v-row align="center" no-gutters>
        <v-col cols="12">
          <v-text-field
            v-show="!loading"
            v-model="search"
            append-icon="mdi-magnify"
            class="mx-10 py-4"
            label="Procurar"
            hide-details
            single-line
          />
        </v-col>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="consultas"
            :items-per-page="itemsPerPage"
            :search.sync="search"
            :page.sync="currentPage"
            :loading="loading"
            :hide-default-header="loading"
            :hide-default-footer="loading"
            no-data-text="Nenhum relatório disponível"
            no-results-text="Nenhum registro correspondente encontrado"
            :mobile-breakpoint="0"
          >
            <template v-slot:item="row">
              <tr @click="selecionarConsulta(row.item)">
                <td class="button cursor-pointer" style="max-width: 70px">{{ row.item.id }}</td>
                <td class="button cursor-pointer" style="max-width: 220px">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div class="text-truncate" v-bind="attrs" v-on="on">
                        {{ row.item.nome }}
                      </div>
                    </template>
                    <span>{{ row.item.nome }}</span>
                  </v-tooltip>
                </td>
                <td class="button cursor-pointer text-no-wrap">{{ row.item.usuario }}</td>
                <td class="button cursor-pointer">
                  {{ row.item.linhas | parseNumberToIntegerBR }}
                </td>
              </tr>
            </template>
            <template v-slot:[`footer.page-text`]>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="primary" v-bind="attrs" v-on="on" @click="getRelatoriosStatusSucesso()">mdi-refresh</v-icon>
                </template>
                <span>Clique aqui para recarregar os relatórios</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
  import RelatoriosService from '@/services/RelatoriosService.js';

  export default {
    props: {
      activated: {
        type: Boolean,
        required: true
      }
    },

    emits: ['update:activated', 'selected'],

    data: () => ({
      currentPage: 1,
      itemsPerPage: 5,
      search: undefined,
      headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Nome',
          value: 'nome'
        },
        {
          text: 'Usuário',
          value: 'usuario'
        },
        {
          text: 'Linhas',
          value: 'linhas'
        }
      ],
      consultas: [],
      loading: false
    }),

    computed: {
      dialog() {
        return this.activated;
      }
    },

    created() {
      this.getRelatoriosStatusSucesso();
    },

    methods: {
      getRelatoriosStatusSucesso() {
        this.consultas = [];
        this.loading = true;

        RelatoriosService.getConsultasByStatus('SUCESSO')
          .then((response) => {
            response.data.consultas.forEach((element) => {
              this.consultas.push({
                id: element.id,
                nome: element.nome,
                usuario: element.usuario.nome,
                linhas: element.numero_registros
              });
            });
          })
          .catch(() => this.$toast.error('Erro ao recuperar consultas', '', { position: 'topRight' }))
          .finally(() => (this.loading = false));
      },

      selecionarConsulta(consulta) {
        const data = { id: consulta.id, nome: consulta.nome };
        this.$emit('selected', data);

        setTimeout(() => {
          this.search = '';
        }, 500);
      }
    },

    watch: {
      search() {
        this.currentPage = 1;
      }
    }
  };
</script>

<style scoped>
  .cursor-pointer:hover {
    cursor: pointer;
  }
</style>
